import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Card, CardBody, Input, Label, FormGroup, Col } from 'reactstrap';
import { Translate, I18n } from 'react-redux-i18n';
import Datetime from 'react-datetime';
import EndDatetime from 'components/EndDatetime';
import ControlTemplate from './ControlTemplate';

export const TYPE_PERIOD = 'period';
export const TYPE_DURATION = 'duration';

function CustomDatetime({ ...props }) {
    return (
        <Datetime
            dateFormat={ I18n.t('datetime_format.date') }
            timeFormat={ I18n.t('datetime_format.time') }
            closeOnSelect={ true }
            { ...props }
        />
    );
}

class SystemCouponTimetable extends Component {
    static propTypes = {
        couponBody: PropTypes.shape({}),
        viewOnly: PropTypes.bool,
    };

    static defaultProps = {
        couponBody: {},
        viewOnly: false,
    };

    constructor(props) {
        super(props);
        const { couponBody } = props;
        const { valid_from, valid_to } = couponBody;

        this.dates = {};
        this.state = {
            validType: ((valid_from && valid_to) ||
                        (!couponBody.id && !valid_from && !valid_to) ? TYPE_PERIOD : TYPE_DURATION),
        };

        this.elValidFrom = React.createRef();
        this.elValidTo = React.createRef();
    }

    componentDidMount() {
        const { couponBody } = this.props;
        const { valid_from, valid_to } = couponBody;

        this.dates = {
            valid_from: valid_from && moment(valid_from),
            valid_to: valid_to && moment(valid_to),
        };
    }

    checkDateValidation = (el, datetime) => {
        const currTime = moment(datetime);
        const isValid = currTime.isValid();

        if (!isValid) {
            el.setCustomValidity(I18n.t('coupon.invalid_date'));
        }
        else {
            this.dates[el.name] = currTime;

            el.setCustomValidity('');
        }

        return isValid;
    }

    checkSequence = (fromTime, toTime) => {
        return (fromTime && toTime && toTime.diff(fromTime) > 0);
    }

    handleDatesChanged = ref => datetime => {
        this.checkDateValidation(ref.current, datetime);

        const { validType } = this.state;
        const { valid_from, valid_to } = this.dates;

        if (validType === TYPE_PERIOD && !this.checkSequence(valid_from, valid_to)) {
            this.elValidTo.current.setCustomValidity(I18n.t('coupon.wrong_sequence_date'));
        }
    }

    handlevalidTypeChanged = e => {
        this.setState({
            validType: e.currentTarget.value,
        });
    }

    renderRedeemType() {
        const { viewOnly } = this.props;
        const { validType } = this.state;

        return (
            viewOnly ?
                (
                    <Col sm={ 3 }>
                        <Translate className="type-badge" value={ `coupon.redeem_type_${ validType }` } />
                    </Col>
                ) :
                (
                    <Col sm={ 3 }>
                        <FormGroup check>
                            <Label check>
                                <Input
                                    type="radio"
                                    name="valid_type"
                                    value={ TYPE_PERIOD }
                                    defaultChecked={ validType === TYPE_PERIOD }
                                    onChange={ this.handlevalidTypeChanged }
                                />
                                <Translate value="coupon.redeem_type_period" />
                            </Label>
                        </FormGroup>
                        <FormGroup check>
                            <Label check>
                                <Input
                                    type="radio"
                                    name="valid_type"
                                    value={ TYPE_DURATION }
                                    defaultChecked={ validType === TYPE_DURATION }
                                    onChange={ this.handlevalidTypeChanged }
                                />
                                <Translate value="coupon.redeem_type_duration" />
                            </Label>
                        </FormGroup>
                    </Col>
                )
        );
    }

    render() {
        const { couponBody, viewOnly } = this.props;
        const { validType } = this.state;

        return (
            <>
                <Translate value="coupon.timetable" className="caption" tag="h2" />
                <Card>
                    <CardBody>
                        <FormGroup row>
                            <Label sm={ 2 }>
                                <Translate value="coupon.redeem_type" className="field required" />
                            </Label>
                            { this.renderRedeemType() }
                        </FormGroup>
                        {
                            validType === TYPE_PERIOD ?
                                (
                                    <>
                                        <ControlTemplate large={ viewOnly } captionKey="valid_from">
                                            <CustomDatetime
                                                inputProps={ {
                                                    name: 'valid_from',
                                                    required: true,
                                                    autoComplete: 'off',
                                                    ref: this.elValidFrom,
                                                } }
                                                initialValue={
                                                    couponBody.valid_from ?
                                                        moment(
                                                            couponBody.valid_from
                                                        ).format(I18n.t('datetime_format.long')) :
                                                        undefined
                                                }
                                                onChange={ this.handleDatesChanged(this.elValidFrom) }
                                            />
                                        </ControlTemplate>
                                        <ControlTemplate large={ viewOnly } captionKey="valid_to">
                                            <EndDatetime
                                                inputProps={ {
                                                    name: 'valid_to',
                                                    required: true,
                                                    autoComplete: 'off',
                                                    ref: this.elValidTo,
                                                } }
                                                initialValue={
                                                    couponBody.valid_to ?
                                                        moment(
                                                            couponBody.valid_to
                                                        ).format(I18n.t('datetime_format.long')) :
                                                        undefined
                                                }
                                                initialViewDate={ couponBody.valid_to ?
                                                    moment(couponBody.valid_to) : undefined }
                                                onChange={ this.handleDatesChanged(this.elValidTo) }
                                            />
                                        </ControlTemplate>
                                    </>
                                ) :
                                null
                        }
                        {
                            validType === TYPE_DURATION ?
                                (
                                    <ControlTemplate withUnit captionKey="valid_duration">
                                        <Input
                                            type="number"
                                            name="valid_duration"
                                            min="1"
                                            step="1"
                                            defaultValue={ couponBody.valid_duration }
                                            required
                                        />
                                        <Translate value="coupon.days" />
                                    </ControlTemplate>
                                ) :
                                null
                        }
                    </CardBody>
                </Card>
            </>
        );
    }
}

export default SystemCouponTimetable;
